













































import '../assets/scss/init.scss'
import { Component, Vue, namespace, Watch } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { ICssVariables, IStyle } from '~/assets/interfaces/classes'
import { IMeta } from '~/assets/interfaces/meta'
import { ISiteScriptItem } from '~/assets/interfaces/site'
import { CONFIG_CSS_API } from '~/assets/config/api-path'
import { filterUrl } from '~/assets/filters/url'
import { runIdle } from '~/assets/functions/runIdle'
import { getAbsoluteUrl, getOpenGraphType } from '~/assets/functions/open-graph'

const siteStore = namespace('site')
const pageStore = namespace('page')

@Component({
  components: {
    LazyHydrate,
    componentHeader: () => import('~/components/header/header.vue'),
    componentFooter: () => import('~/components/footer/footer.vue'),
    ComponentSystemUnderReconstruction: () =>
      import('~/components/system/sytem-under-reconstruction.vue'),
    ComponentLayoutGeneral: () => import('~/components/layout/general.vue'),
    ComponentProductQuickViewHost: () =>
      import('~/components/products/quick-view/quick-view-host.vue'),
    ComponentMarketingPopupManager: () =>
      import('~/components/marketing-popup/manager.vue'),
    ComponentAuth: () => import('~/components/auth/auth.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentLoadingDots: () => import('~/components/loading/dots.vue'),
    ComponentSkeletonRect: () => import('~/components/skeleton/rect.vue'),
  },
})
export default class layoutDefault extends Vue {
  @pageStore.State('meta') private meta!: IMeta
  @siteStore.Getter('getOptionsQuickView') private isQuickViewEnabled!: boolean
  @siteStore.State('token') private token!: string | null
  @siteStore.State('origin') private origin!: string
  @siteStore.State('brand') private brand!: string
  @siteStore.State('cssVariables') private cssVariables!: ICssVariables | null
  @siteStore.State('scripts') private scripts!: ISiteScriptItem[]
  @siteStore.State('isUnderConstruction') private isUnderConstruction!: boolean

  private isComponentHeaderLoaded = false

  private isShowAuthPopup = false
  private isComponentAuthLoaded = false
  isMounted = false

  public $style!: IStyle

  private get cssVariablesStyle() {
    let style = ':root {'
    for (const item in this.cssVariables) {
      style =
        style +
        (item === 'google-font-family' ? '--' : '--color-') +
        item +
        ': ' +
        this.cssVariables[item] +
        ';'
    }
    style = style + '}'
    return style
  }

  private get googleFontsUrl() {
    if (this.cssVariables && this.cssVariables['google-font-family']) {
      const googleFont = this.cssVariables['google-font-family']
        .trim()
        .replace(/\s/g, '+')
      return `https://fonts.googleapis.com/css2?family=${googleFont}:wght@400;500;700&display=swap`
    }
    return null
  }

  private get googleFontLinks() {
    if (this.cssVariables && this.cssVariables['google-font-family']) {
      return [
        {
          rel: 'preconnect',
          href: 'https://fonts.googleapis.com',
        },
        {
          rel: 'preconnect',
          href: 'https://fonts.gstatic.com',
          crossorigin: true,
        },
        {
          rel: 'preload',
          as: 'style',
          href: this.googleFontsUrl,
        },
        {
          rel: 'stylesheet',
          href: this.googleFontsUrl,
          media: 'print',
          onload: "this.onload=null;this.media='all';",
        },
      ]
    } else {
      return []
    }
  }

  private head() {
    const base: any = {
      __dangerouslyDisableSanitizers: ['script', 'style', 'noscript'],
      bodyAttrs: {
        class: this.$style.body,
      },
      title: this.meta.title || '',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description || '',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta.keywords || '',
        },
        {
          hid: 'robots',
          name: 'robots',
          content: this.meta.robots || '',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.meta.description || '',
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.meta.title || '',
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: this.openGraphType,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.canonicalUrl,
        },
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: 'ru_RU',
        },
        {
          hid: 'og:site_name',
          name: 'og:site_name',
          property: 'og:site_name',
          content: this.brand || '',
        },
      ],
      link: [
        {
          rel: 'canonical',
          hid: 'canonical',
          href: this.canonicalUrl,
        },
      ],
      style: [
        {
          innerHTML: this.cssVariablesStyle,
        },
      ],
    }
    base.meta.push(
      {
        hid: 'twitter:card',
        name: 'twitter:card',
        content: this.openGraphImage ? 'summary_large_image' : 'summary',
      },
      {
        hid: 'twitter:title',
        name: 'twitter:title',
        content: this.meta.title || '',
      },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content: this.meta.description || '',
      }
    )
    if (this.openGraphImage) {
      base.meta.push(
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.openGraphImage,
        },
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: this.meta.title || '',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: this.openGraphImage,
        },
        {
          hid: 'twitter:image:alt',
          name: 'twitter:image:alt',
          content: this.meta.title || '',
        }
      )
    }
    base.link.push(...this.googleFontLinks)
    this.scripts.forEach((item) => {
      base[item.type] = base[item.type] || []
      base[item.type].push({ ...item.attr })
    })
    return base
  }

  private get canonicalUrl() {
    return getAbsoluteUrl(
      this.meta.canonical || this.$route.fullPath,
      this.origin
    )
  }

  private get openGraphImage() {
    return getAbsoluteUrl(this.meta.image, this.origin)
  }

  private get openGraphType() {
    return getOpenGraphType(this.$route.name)
  }

  @Watch('token', { immediate: true })
  private tokenHandler(val: string | null) {
    if (val) {
      this.$axios.setToken(val)
    }
  }

  private created() {
    this.$nuxt.$on('open-auth-popup', () => {
      this.isShowAuthPopup = true
    })
  }

  mounted() {
    runIdle(() => {
      this.isMounted = true

      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = filterUrl(this.$config.baseURL + CONFIG_CSS_API)
      link.type = 'text/css'
      document.head.appendChild(link)
    })
  }
}
